// IMPORT WRAP PAGE ELEMENT
import CustomLayout from "./wrapPageElement"

// PRISM.JS
require('./src/styles/prism-themes/xonokai.css')

// EXPORT WRAP PAGE ELEMENT
export const wrapPageElement = CustomLayout